import {formatNum, getOrderDetail,getOrderDetail2, getUrlParams, formateVaNumber} from "./../util/util";
let orderNum = getUrlParams('orderNum');
let type = 'DANA';
if(!getUrlParams("orderNum")) alert("Nomor perintah hilang");

export function getDanaOrderDetail(){

  // $(".mask").show();

  getOrderDetail({
    method: "DANA",
    orderNum
}, res=>{
    let {
        vaNumber,payStatus,method
    } = res.data || {};
    if ("SUCCESS" == payStatus) {
      window.location.href = "./SUCCESS.html?orderNum="+orderNum;
  } else {
      window.location.href = vaNumber;
  }
  // if (method != '' && method != type) {
  //   window.location.replace("./" + method + ".html?type=" + method + "&orderNum=" + orderNum);
  //   return;
  // }
  autoRefresh();
}, error=>{
    console.log(error);
});
}



    function autoRefresh() {
      setInterval(function () {
          getOrderDetail2({
              method: type,
              orderNum
          }, res => {
              let {
                  payStatus
              } = res.data || {};
              if ("SUCCESS" == payStatus) {
                window.location.href = "./SUCCESS.html?orderNum="+orderNum;
              }
          });
      }, 15000);
  }
